import React, { useEffect, useState } from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner"; // Import the library
import styles from "./PreviewBarcode.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { ReactComponent as BarCodeIcon } from "assets/svg/barcode-scan-svgrepo-com.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BarScan from "../../../../../assets/svg/bar_scan.svg"
const PreviewBarcode = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [scanning, setScanning] = useState(false); // State to toggle barcode scanner
  const [barcodeValue, setBarcodeValue] = useState(""); // State to store scanned value

  const handleBarcodeScan = (err, result) => {
    if (result) {
      setBarcodeValue(result.text); // Update input with scanned value
      setScanning(false); // Close the scanner
    }
    if (err) {
      console.error(err);
    }
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          {props?.data?.required && <span style={{ color: "red" }}>*</span>}
          <span>{props?.data?.value || props?.name}</span>
          {props?.instructions || props?.data?.media?.length ? (
            <div className={styles?.icon}>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        <div className={styles.inputText}>
          <input
            className={styles.textField}
            placeholder="Scan or type barcode"
            value={barcodeValue}
            onChange={(e) => setBarcodeValue(e?.target?.value)}
          />
          {/* <BarCodeIcon
            className={styles.icon}
            onClick={() => setScanning(true)}
          /> */}
          <img src={BarScan} alt="bar_scan" className={styles.icon}
            onClick={() => setScanning(true)} />
        </div>
      </div>
      {scanning && (
        <div className={styles.scanner}>
          <BarcodeScannerComponent
            width="100%"
            height="100%"
            onUpdate={handleBarcodeScan}
          />
          {/* <button
            className={styles.closeScanner}
            onClick={() => setScanning(false)}
          >
            Close Scanner
          </button> */}
          <div onClick={() => setScanning(false)} className={styles?.back}>
            <ArrowBackIcon />
          </div>
        </div>
      )}
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PreviewBarcode;
